"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const zod_1 = require("zod");
const work_entities_fields_validators_1 = require("@App/helpers/work-entities-fields-validators");
const validate_1 = require("@App/helpers/validate");
const writer_schema_1 = __importDefault(require("@Entities/schemas/work/writer-schema"));
const error_messages_1 = require("@Entities/schemas/work/error-messages");
const error_messages_2 = require("@Const/error-messages");
const publisherSchema = zod_1.z.object({
    id: zod_1.z
        .number({ invalid_type_error: (0, error_messages_1.numericMessage)('ID') })
        .int((0, error_messages_1.integerMessage)('Id'))
        .optional()
        .nullable(),
    ipId: zod_1.z
        .string({ invalid_type_error: (0, error_messages_1.stringMessage)('IPID') })
        .optional()
        .nullable(),
    localId: zod_1.z.number({ invalid_type_error: (0, error_messages_1.numericMessage)('Local ID') }).optional(),
    publisherName: zod_1.z
        .string({ invalid_type_error: (0, error_messages_1.stringMessage)('Publisher name') })
        .max(200, (0, error_messages_1.stringSizeMaxMessage)('Publisher name', 200))
        .refine((val) => !(0, work_entities_fields_validators_1.containsNewLine)(val), (0, error_messages_1.newlineMessage)('Publisher name')),
    hfaPublisherNumber: zod_1.z
        .string({ invalid_type_error: (0, error_messages_1.stringMessage)('Publisher number') })
        .optional()
        .nullable(),
    ipiNumber: zod_1.z
        .string()
        .nullable()
        .refine((ipiNumber) => (0, validate_1.IPIValidator)(ipiNumber, false), 'Invalid IPI Number'),
    publisherShare: zod_1.z
        .number({ invalid_type_error: (0, error_messages_1.numericMessage)('Publisher share') })
        .nonnegative((0, error_messages_1.nonNegativeMessage)('Publisher share'))
        .max(100.06, (0, error_messages_1.maxNumberMessage)('Publisher share', 100.6))
        .nullable(),
    amend: zod_1.z
        .boolean({ invalid_type_error: (0, error_messages_1.booleanMessage)('Amend') })
        .optional()
        .nullable(),
    mailingAddress: zod_1.z
        .string({ invalid_type_error: (0, error_messages_1.stringMessage)('Mailing address') })
        .optional()
        .nullable(),
    hfaAgreement: zod_1.z
        .boolean({ invalid_type_error: (0, error_messages_1.booleanMessage)('HFA agreement') })
        .optional()
        .nullable(),
    email: zod_1.z
        .string({ invalid_type_error: (0, error_messages_1.stringMessage)('Email address') })
        .optional()
        .nullable(),
    phone: zod_1.z
        .string({ invalid_type_error: (0, error_messages_1.stringMessage)('Phone number') })
        .optional()
        .nullable(),
    website: zod_1.z
        .string({ invalid_type_error: (0, error_messages_1.stringMessage)('Website') })
        .optional()
        .nullable(),
});
const originalPublisherSchema = publisherSchema
    .extend({
    administratorPublishers: zod_1.z.array(publisherSchema),
    writers: zod_1.z.array(writer_schema_1.default),
})
    .superRefine((schema, ctx) => {
    if (schema.administratorPublishers.length === 0) {
        if (!schema.publisherShare || schema.publisherShare <= 0) {
            ctx.addIssue({
                code: zod_1.z.ZodIssueCode.custom,
                message: error_messages_2.PUBLISHER_SHARE_IS_0_ERROR,
                path: ['publisherShare'],
            });
        }
    }
    else {
        schema.administratorPublishers.forEach((ap, index) => {
            if (!ap.publisherShare || ap.publisherShare <= 0) {
                ctx.addIssue({
                    code: zod_1.z.ZodIssueCode.custom,
                    message: error_messages_2.PUBLISHER_SHARE_IS_0_ERROR,
                    path: ['administratorPublishers', index, 'publisherShare'],
                });
            }
        });
    }
});
exports.default = originalPublisherSchema;
